"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.passwordMeetsRequirements = void 0;
const passwordMeetsRequirements = (password) => password.length > 32 ||
    (password.length >= 11 &&
        !!password.match(/[a-z]/g) &&
        !!password.match(/[A-Z]/g) &&
        !!password.match(/[0-9]/g) &&
        !!password.match(/[ ^!@#$%&*(){}+=_\-<>,.?/[\]\\|;'"]/g));
exports.passwordMeetsRequirements = passwordMeetsRequirements;
//# sourceMappingURL=passwordComplexity.js.map